import { Component, Vue, Prop } from 'vue-property-decorator'
import { IsJsonString } from '@/plugins/helpers'
import { isString } from 'lodash'

@Component({
    methods: { IsJsonString },
})
export default class EditorViewer extends Vue {
    @Prop() description!: any
    // descriptionObject: any = null

    get descriptionObject() {
        let res: any = null

        if (this.description) {
            if (IsJsonString(this.description)) {
                let parsedInit = JSON.parse(this.description)
                if (parsedInit.type) {
                    if (parsedInit.type == 'editorjs') {
                        res = parsedInit.data
                    } else if (parsedInit.type == 'text') {
                        res = { blocks: [{ type: 'paragraph', data: { text: parsedInit.data } }] }
                    }
                } else {
                    res = parsedInit
                }
            } else {
                res = { blocks: [{ type: 'paragraph', data: { text: this.description } }] }
            }
        }

        return res
    }

    // mounted(){
    //     if (IsJsonString(this.description)) {
    //         this.descriptionObject = JSON.parse(this.description)
    //       } else {
    //         this.descriptionObject = {
    //           blocks: [
    //             {
    //               data: { text: this.description },
    //               type: "paragraph"
    //             }
    //           ]
    //         }
    //       }
    // }
}
